import { useScrollReveal } from '../hooks/useScrollReveal';

export default function Footer() {
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <footer className="bg-background-100/60 border-t border-background-300/20 relative">
      {/* 顶部分隔金线 */}
      <div className="absolute top-0 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-gold-300/40 to-transparent pointer-events-none" />

      <div ref={ref} className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-20">
        <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
            <div className="md:col-span-4">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-gold-400 to-gold-600 flex items-center justify-center gold-shimmer">
                  <i className="ri-brain-line text-white text-sm" />
                </div>
                <span className="font-heading text-lg font-bold text-gold-700">
                  AI思政评课系统
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
                基于人工智能技术的思政课教学质量智能评价系统，从天津样板走向全国方案，助力高校思政课教学改革与质量治理。
              </p>
            </div>

            <div className="md:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-1 h-4 rounded-full bg-gradient-to-b from-gold-400 to-gold-300" />
                <h4 className="text-xs font-body font-semibold text-gold-700 uppercase tracking-wider">
                  核心技术
                </h4>
              </div>
              <ul className="space-y-2.5">
                {['多模态分析', '语义理解', '情感识别', '行为检测'].map(item => (
                  <li key={item} className="text-sm text-foreground-600 hover:text-gold-600 transition-colors duration-200 cursor-default">{item}</li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-1 h-4 rounded-full bg-gradient-to-b from-gold-400 to-gold-300" />
                <h4 className="text-xs font-body font-semibold text-gold-700 uppercase tracking-wider">
                  应用场景
                </h4>
              </div>
              <ul className="space-y-2.5">
                {['教师反思', '同行评课', '督导评估', '质量监测'].map(item => (
                  <li key={item} className="text-sm text-foreground-600 hover:text-gold-600 transition-colors duration-200 cursor-default">{item}</li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-1 h-4 rounded-full bg-gradient-to-b from-gold-400 to-gold-300" />
                <h4 className="text-xs font-body font-semibold text-gold-700 uppercase tracking-wider">
                  关于项目
                </h4>
              </div>
              <ul className="space-y-2.5">
                {['项目背景', '发展历程', '可信验证', '合作伙伴'].map(item => (
                  <li key={item} className="text-sm text-foreground-600 hover:text-gold-600 transition-colors duration-200 cursor-default">{item}</li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-1 h-4 rounded-full bg-gradient-to-b from-gold-400 to-gold-300" />
                <h4 className="text-xs font-body font-semibold text-gold-700 uppercase tracking-wider">
                  联系我们
                </h4>
              </div>
              <ul className="space-y-2.5">
                <li className="text-sm text-foreground-600 hover:text-gold-600 transition-colors duration-200 cursor-default">项目咨询</li>
                <li className="text-sm text-foreground-600 hover:text-gold-600 transition-colors duration-200 cursor-default">技术支持</li>
                <li className="text-sm text-foreground-600 hover:text-gold-600 transition-colors duration-200 cursor-default">合作洽谈</li>
              </ul>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 rounded-lg glass border-white/50 flex items-center justify-center hover:border-gold-300/50 hover:scale-110 active:scale-95 transition-all duration-300">
                  <i className="ri-mail-line text-gold-500 text-sm" />
                </a>
                <a href="#" className="w-8 h-8 rounded-lg glass border-white/50 flex items-center justify-center hover:border-gold-300/50 hover:scale-110 active:scale-95 transition-all duration-300">
                  <i className="ri-phone-line text-gold-500 text-sm" />
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-300/20 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2024 AI思政课智能听评课系统项目组. 保留所有权利.
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-gold-600 transition-colors">隐私政策</a>
              <span className="text-foreground-300">|</span>
              <a href="#" className="hover:text-gold-600 transition-colors">使用条款</a>
              <span className="text-foreground-300">|</span>
              <a href="#" className="hover:text-gold-600 transition-colors">可信验证</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}